import React from "react";
import Form from "./Form";
import { FormattedMessage } from "react-intl";
import { APP_VERSION } from "../../constants";
import AuthLayout from "../../layouts/AuthLayout";

const SetPassword = ({ reset }) => {

  return (

    <div className='w-full h-full flex py-5 justify-center items-center bg-gradient-to-tr bg-base-bg overflow-y-auto'>

      <div className="flex flex-col items-center w-full ">
        <img src="/images/influencee.png" className='mx-auto w-[150px] pb-5 ' />
        <div className=' border-base w-full md:w-[50%] lg:w-[40%] xl:w-[30%] md:max-w-[500px] mx-auto md:px-4 pt-10 pb-10 bg-content-bg md:rounded-[20px] shadow-xl'>
          <h1 className='text-3xl font-bold text-center text-t-light'>
            <FormattedMessage id="set_password" defaultMessage={"Set Password"} />
          </h1>
          {
            <p className='text-center text-sm text-t-light w-[90%] mx-auto'>
              <FormattedMessage id="set_password_desc" defaultMessage={"Please set your new password by following the instructions below."} />
            </p>
          }
          <Form reset={reset} />
        </div>
      </div>
    </div>


  );
};

export default SetPassword;
